import { Container } from '@material-ui/core';
import Page from '../../components/Page';

export default function ConfigScheduler() {
  return (
    <Page title="Dashboard: Api's | ZIMTA">
      <Container>
        <div> Config Scheduler</div>
      </Container>
    </Page>
  );
}
